import { ButtonV2, TooltipV2 } from '@cimplico/components';
import { LinkIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import NewLinkDialog from '../../../files/NewLinkDialog';

type NewLinkProps = {
    disabled?: boolean;
    onCreate?: (linkId?: string | undefined) => void;
    folderId: string;
};
function NewLink({ disabled, onCreate, folderId }: NewLinkProps): JSX.Element {
    const [newLink, setNewLink] = useState(false);
    return (
        <>
            {/* NEW LINK CONFIRMATION */}
            {newLink && (
                <NewLinkDialog
                    parentFolderId={folderId}
                    onClose={(): void => setNewLink(false)}
                    onCreate={(id): void => {
                        if (onCreate) {
                            onCreate(id);
                        }
                        setNewLink(false);
                    }}
                />
            )}

            <div>
                <TooltipV2 message="Add new link" disabled={disabled}>
                    <ButtonV2
                        size="sm"
                        type="hollow"
                        leftIcon={<LinkIcon />}
                        onClick={(): void => setNewLink(true)}
                        isDisabled={disabled}
                    />
                </TooltipV2>
            </div>
        </>
    );
}

export default NewLink;
